import {Popper, PopperTrigger} from '@baidu/luffy-comp-popper';
import {ReactNode, useCallback, useRef, useState} from 'react';
import MessageContainer, {IMessageContainer} from '../MessageContainer';
import styles from './index.module.scss';
interface IPopperProps {
    visible: boolean;
    children?: ReactNode;
    target: HTMLElement;
    placement?:
    | 'top-start'
    | 'top'
    | 'top-end'
    | 'right-start'
    | 'right'
    | 'right-end'
    | 'bottom-end'
    | 'bottom'
    | 'bottom-start'
    | 'left-end'
    | 'left'
    | 'left-start';
    className?: string;
    onPopperMouseEnter?: () => void;
    onPopperMouseLeave?: () => void;
    title?: string | ReactNode;
    content: string | ReactNode;
    visibleBtns?: boolean;
    width?: number;
    disablePortal?: boolean;
    gotItTagCustom?: string;
    withArrow?: boolean;
    eventsEnabled?: boolean;
    modifiers?: any;
    portalContainer?: any;
    onChange?: any;
}

type IGuideBaseProps = IPopperProps & IMessageContainer;
const GuideBaseWithLuffy = (props: IGuideBaseProps) => {
    const {
        children, visible, target, name,
        placement, modifiers, content, title,
        buttonContent, onChangeVisible, eventsEnabled,
        onClickButtonToClose, disablePortal, portalContainer,
        onChange, onClickCancel,
    } = props;

    const [, forceUpdate] = useState(null);
    // 尽量减少强制渲染次数
    const isDirty = useRef(true);
    const updateCount = useRef(0);

    const forceUpdateWhileChange = () => {
        // 防止长页面导致的渲染阻塞，在此强行渲染
        updateCount.current++;
        // warning:做一个兜底，一旦死循环直接关闭(luffyPopper的潜在bug)
        if (updateCount.current >= 50) {
            onChangeVisible(false);
            return;
        }
        if (isDirty.current) {
            isDirty.current = false;
            setTimeout(() => {
                if (!isDirty.current) {
                    forceUpdate(null);
                    isDirty.current = true;
                    updateCount.current = 0;
                }
            }, 0);
        }
    };

    return <PopperTrigger visible={visible} target={target} onChange={onChange}>
        {children}
        <Popper
            className={`${styles.popperWrap} ${name ? styles[name] : ''}`}
            withArrow
            placement={placement}
            eventsEnabled={eventsEnabled}
            modifiers={modifiers || null}
            disablePortal={disablePortal}
            onChange={forceUpdateWhileChange}
            // 此处必须这么写否则浏览器会报错
            portalcontainer={portalContainer}
            matchMinWidthToTarget
        >
            <MessageContainer
                content={content}
                title={title}
                buttonContent={buttonContent}
                onClickButtonToClose={onClickButtonToClose}
                onChangeVisible={onChangeVisible}
                onClickCancel={onClickCancel}
                name={name}
            />
        </Popper>
    </PopperTrigger>;
};

export default GuideBaseWithLuffy;
